import React from 'react';
import { Filter } from './types';
import { DateRangeFilter } from './filters/DateRangeFilter';
import { SelectFilter } from './filters/SelectFilter';
import { MultiSelectFilter } from './filters/MultiSelectFilter';

interface FilterRendererProps {
  filter: Filter;
  className?: string;
}

export const FilterRenderer: React.FC<FilterRendererProps> = ({
  filter,
  className,
}) => {
  switch (filter.type) {
    case 'dateRange':
      return <DateRangeFilter filter={filter} className={className} />;
    case 'select':
      return <SelectFilter filter={filter} className={className} />;
    case 'multiSelect':
      return <MultiSelectFilter filter={filter} className={className} />;
    default:
      console.warn(`Unknown filter type: ${(filter as { type: string }).type}`);
      return null;
  }
};
